import { observer } from 'mobx-react-lite';

import { Box } from '@mui/material';
import GridContainer from '../components/container/GridContainer';
import Config from '../config';

const NewsPage = observer(() => {
  const configuration = Config[process.env.REACT_APP_CLIENT || 'wbg'];
  return (
    <Box width={1} height="75vh">
      <GridContainer>
        <iframe
          width="99.5%"
          height="100%"
          title="news"
          frameBorder="0"
          src={configuration.linkToNewsPage || ''}
        />
      </GridContainer>
    </Box>
  );
});

export default NewsPage;
